(() => {
  const script = document.querySelector('script[data-ufi-enquiry-label]');
  if (!script) return;
  const label = script.dataset.ufiEnquiryLabel;
  const addText = /\badd(?: all)? to (?:cart|basket|quote|enquiry)\b/gi;
  const cartLabel = script.dataset.ufiCartLabel;
  const replace = text => text.replace(addText, label).replace(/\b(?:quote cart|enquiry cart|shopping cart)\b/gi, cartLabel);
  const nodes = '#content .ufi-app-section button,#content .ufi-app-section [role="button"],#content .ufi-app-section input[type="submit"],#content .ufi-app-section input[type="button"],#content .ufi-app-section a';
  function replaceLabels() {
    document.querySelectorAll(nodes).forEach(button => {
      if (button.matches('input')) {
        const next = replace(button.value);
        if (next !== button.value) button.value = next;
      } else {
        const walker = document.createTreeWalker(button, NodeFilter.SHOW_TEXT);
        while (walker.nextNode()) {
          const text = walker.currentNode;
          const next = replace(text.nodeValue);
          if (next !== text.nodeValue) text.nodeValue = next;
        }
      }
      ['aria-label', 'title'].forEach(name => {
        const current = button.getAttribute(name);
        if (!current) return;
        const next = replace(current);
        if (next !== current) button.setAttribute(name, next);
      });
    });
  }
  replaceLabels();
  const content = document.getElementById('content');
  if (content) new MutationObserver(replaceLabels).observe(content, {subtree:true, childList:true, characterData:true, attributes:true, attributeFilter:['value','aria-label','title']});
})();

